import { Component, OnInit } from '@angular/core';
import { FormsModule, FormControl,  FormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';
import { MatDialog } from '@angular/material';
import { SharedService } from '../../shared/shared.service';
import { CustomerEnrollService } from '../customer-enroll.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {AbstractControl} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PlanService } from '../../plan/plan.service';

// global const
const LETTERS_REGEX = /^[A-Za-z ]+$/;
const MOBILE_REGEX = /^\d{10}$/;
const PASSWORD_REGEX = /((?=.*\d)(?=.*[A-Za-z])(?=.*[0-9]).{6,18})/;
const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const DATE_REGEX = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;

@Component({
  selector: 'app-customer-enroll-wizard',
  templateUrl: './customer-enroll-wizard.component.html',
  styleUrls: ['./customer-enroll-wizard.component.css']
})
export class CustomerEnrollWizardComponent implements OnInit {
  // enrollment form wizard validation
  firstNameFormControl = new FormControl('', [
  Validators.required,
  Validators.pattern(LETTERS_REGEX)]);
  lastNameFormControl = new FormControl('', [
  Validators.required,
  Validators.pattern(LETTERS_REGEX)]);
  mobilePhoneFormControl = new FormControl('', [
  Validators.required,
  Validators.pattern(MOBILE_REGEX)]);
  billingAddress1FormControl = new FormControl('', [
  Validators.required]);
  cityFormControl = new FormControl('', [
  Validators.required,
  Validators.pattern(LETTERS_REGEX)]);
  stateFormControl = new FormControl('', [
  Validators.required,
  Validators.pattern(LETTERS_REGEX)]);
  zipCodeFormControl = new FormControl('', [
  Validators.required,
  Validators.pattern(ZIPCODE_REGEX)]);
  // wizard public variables
  public doing_personal: string;
  public doing_account: string;
  public doing_service: string;
  public doing_summary: string;
  public complete_personal: string;
  public complete_account: string;
  public complete_service: string;
  public complete_summary: string;
  public is_doing_personal: boolean;
  public is_doing_account: boolean;
  public is_doing_service: boolean;
  public is_doing_summary: boolean;
  public is_completed_personal: boolean;
  public is_completed_account: boolean;
  public is_completed_service: boolean;
  public is_completed_summary: boolean;
  public customer_enroll_object: Object;
  public component_load: boolean;
  public is_start_date_today:boolean = false;

  // personal wizard variables
  public first_name;
  public last_name;
  public mobile_phone_number;
  public date_of_birth;
  public enroll_personal_valid: boolean;
  public maxDate = new Date();
  public is_mobile_no_exist: boolean;
  public date_of_birth_1;
  public month: any;
  public date: any;
  public year: any;
  is_dob_valid: boolean;
  public birth: any;
  date_error_message: string;

  // account wizard variables
  public create_password: string;
  public confirm_password: string;
  public prefered_language: string;
  public enroll_account_valid: boolean;
  public form ;
  languages = [
    {value: 'English', viewValue: 'English'},
    {value: 'Espanol', viewValue: 'Espa\u00F1ol'}
  ];

  // service wizard variables
  public is_billing_add_as_service_add: boolean;
  public service_type;
  public service_start_date: Date;
  public billing_address;
  public billing_address_2;
  public city;
  public state;
  public zip_code;
  public enroll_service_valid;
  billing_address_obj: Object;
  public minDate = new Date();
  public maxDateService = new Date();
  is_confirm_password_match: boolean;
  public laguage_wizard = 'lg-english';
  public date_service_start: string;
  public service_start_upto_days: any;
  public timeover: any;

  public terms_condition: boolean;
  public is_enroll_processing: boolean;
  public is_enroll_process: boolean;
  public btn_value: string;
  public critical_care: boolean;
  public disable_div: string;
  public ip_Address: string;

  months = [
    {value: 'Month', viewValue: 'Month'},
    {value: '1', viewValue: 'Jan'},
    {value: '2', viewValue: 'Feb'},
    {value: '3', viewValue: 'Mar'},
    {value: '4', viewValue: 'Apr'},
    {value: '5', viewValue: 'May'},
    {value: '6', viewValue: 'Jun'},
    {value: '7', viewValue: 'Jul'},
    {value: '8', viewValue: 'Aug'},
    {value: '9', viewValue: 'Sept'},
    {value: '10', viewValue: 'Oct'},
    {value: '11', viewValue: 'Nov'},
    {value: '12', viewValue: 'Dec'},
    ];
  dates = [{value: 'Day', viewValue: 'Day'}];
  years = [{value: 'Year', viewValue: 'Year'}];

  types = [
  {value: 'Move-In', viewValue: 'Yes'},
  {value: 'Old-User', viewValue: 'No'}
  ];

  private documents:any = {
    en: {
      EFL: '',
      TOS: '',
      PDS: '',
      YRAC: ''
    },
    es: {
      EFL: '',
      TOS: '',
      PDS: '',
      YRAC: ''
    }
  };

  public holidayDates;
  public today;
  myFilter = (d: Date): boolean => {
     const day = d.getDay();
     const calendar_date = this.datePipe.transform(d, 'yyyy-MM-dd');
     const today_date = this.datePipe.transform(this.today, 'yyyy-MM-dd');
     if (today_date === calendar_date) {
        this.is_start_date_today = true;
        if (this.timeover) {
          return false;
        }
     } else {
        this.is_start_date_today = false;
     }
     for (let i = 0; i <= this.holidayDates.length - 1; i++) {
        const holiday_date = this.datePipe.transform(this.holidayDates[i]['event_date'], 'yyyy-MM-dd');
       if (calendar_date === holiday_date) {
        return false;
       }
     }
     return true && day !== 0;
  }

  constructor(private fb: FormBuilder , private activatedRoute: ActivatedRoute ,
    public dialog: MatDialog, private sharedService: SharedService, private planService: PlanService,
    private customerEnrollService: CustomerEnrollService, private localStorageService: LocalStorageService,
    private router: Router, private datePipe: DatePipe) {
        this.fetchAllDocuments();
        
        this.sharedService.getIpAddress()
        .then(res => {
            if (res.ip  !== undefined) {
                this.ip_Address = res.ip
            }
        });

        this.form = fb.group({
        passwordFormControl: ['', Validators.compose([Validators.required, Validators.pattern(PASSWORD_REGEX)])],
        confirmPasswordFormControl: ['']
        }, {
        validator: PasswordValidation.MatchPassword
        })
        this.sharedService.setHeaderTitle('default_page');
        // this.sharedService.setHeaderErrorMessage("personal", false, "notification error", "");
        if (this.localStorageService.get('token') != null) {
          this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
          .then(res => {
              if (res.status === 'success' && res.isTerminated === false) {
                  this.router.navigate(['./dashboard']);
              }else {
                  this.localStorageService.remove('token');
                  this.router.navigate(['./enrollment-wizard']);
              }
          });
        }else {
            this.service_start_upto_days = 0;
            const this_of_obj = this;
            setTimeout(function(){
              if (document.getElementById('which_language').innerHTML === 'English') {
                this_of_obj.laguage_wizard = 'lg-english';
              }else if (document.getElementById('which_language').innerHTML === 'Spanish' ||
              document.getElementById('which_language').innerHTML === 'Español') {
                this_of_obj.laguage_wizard = 'lg-spanish';
              }
              if (document.getElementById('first_name') !== undefined) {
                document.getElementById('first_name').focus();
              }
            }, 500);


              if (this.localStorageService.get('ProductID') == null) {
                this.router.navigate(['./enroll']);
              }
              this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);
              let i = 1905;
              for (i = this.maxDate.getFullYear(); i >= 1905; i--) {
                  this.years.push({value: '' + i, viewValue: '' + i});
              }

              this.date = 'Day';
              this.month = 'Month';
              this.year = 'Year';
              this.component_load = true;
              this.goToStep('personal');

            // personal wizard
              const that = this.sharedService;
              setTimeout(function(){
                that.setHeaderErrorMessage('personal', false, 'notification error', '');
                that.setHeaderTitle('personal');
              }, 10);
              this.enroll_personal_valid = false;
              this.first_name = '';
              this.last_name = '';
              this.mobile_phone_number = '';
              this.date_of_birth = '';
              this.is_mobile_no_exist = false;

              // account wizard
              this.enroll_account_valid = false;
              this.prefered_language = 'English';
              this.disable_div = '';
              // service wizard
              this.is_billing_add_as_service_add = true;
              this.sharedService.getConfigConst()
              .then(res => {
                            if (res.status === 'success') {
                              this.service_start_upto_days = res.results[0]['serviceStartUptoDays'];
                              this.maxDateService.setDate(this.maxDateService.getDate() + (this.service_start_upto_days -  1));
                            }
              });
              this.service_type = 'Move-In';
              this.enroll_service_valid = false;
              this.billing_address_obj = this.localStorageService.get('address_for_billing');
              if (this.billing_address_obj != null) {
                  this.billing_address = this.billing_address_obj['address'];
                  this.billing_address_2 = '';
                  this.city = this.billing_address_obj['city'];
                  this.state = this.billing_address_obj['state'];
                  this.zip_code = this.billing_address_obj['zipcode'];
                }

              // summary wizard
              this.terms_condition = false;
              this.is_enroll_processing = this.terms_condition;
              this.btn_value = 'Sign Up';
              this.is_enroll_process = true;
              this.critical_care = false;
      }

      this.customerEnrollService.getHolidayList({'tdsp': this.localStorageService.get('tdu')})
       .then(res => {
                     if (res.status === 'success') {
                     this.holidayDates = res.calendar;
                     this.today = res.today;
                     this.timeover = res.timeover;
                     }
       });
  }

  fetchAllDocuments(){
    this.planService.getDocument('EFL','English')
        .then(res=>{
          if (res != undefined && res.status == 'success') { 
            this.documents.en['EFL'] = res.result[0].document_url;
            // window.open(res.result[0].document_url, '_blank');
          } 
        });

    this.planService.getDocument('EFL','Spanish')
        .then(res=>{
          if (res != undefined && res.status == 'success') { 
            this.documents.es['EFL'] = res.result[0].document_url;
            // window.open(res.result[0].document_url, '_blank');
          } 
        });

    this.planService.getDocument('TOS','English')
        .then(res=>{
          if (res != undefined && res.status == 'success') { 
            this.documents.en['TOS'] = res.result[0].document_url;
            // window.open(res.result[0].document_url, '_blank');
          } 
        });

    this.planService.getDocument('TOS','Spanish')
        .then(res=>{
          if (res != undefined && res.status == 'success') { 
            this.documents.es['TOS'] = res.result[0].document_url;
            // window.open(res.result[0].document_url, '_blank');
          } 
        });

    this.planService.getDocument('PDS','English')
        .then(res=>{
          if (res != undefined && res.status == 'success') { 
            this.documents.en['PDS'] = res.result[0].document_url;
            // window.open(res.result[0].document_url, '_blank');
          } 
        });

    this.planService.getDocument('PDS','Spanish')
        .then(res=>{
          if (res != undefined && res.status == 'success') { 
            this.documents.es['PDS'] = res.result[0].document_url;
            // window.open(res.result[0].document_url, '_blank');
          } 
        });

    this.planService.getDocument('YRAC','English')
        .then(res=>{
          if (res != undefined && res.status == 'success') { 
            this.documents.en['YRAC'] = res.result[0].document_url;
            // window.open(res.result[0].document_url, '_blank');
          } 
        });

    this.planService.getDocument('YRAC','Spanish')
        .then(res=>{
          if (res != undefined && res.status == 'success') { 
            this.documents.es['YRAC'] = res.result[0].document_url;
            // window.open(res.result[0].document_url, '_blank');
          } 
        });
  }

  viewDocument(documentName: string) {
      let lang = document.getElementById('which_language').innerHTML;

      var urlObj;
      if (lang === 'English') {
        urlObj = this.documents.en;
      }else {
        urlObj = this.documents.es;
      }

      window.open(urlObj[documentName], '_blank');
  }

  // Validation of personal wizard
  enrollPersonalValidate(personal: any) {
    this.is_dob_valid = false;
    if (this.month === 'Month') {
      this.dates = [{value: 'Day', viewValue: 'Day'}];
      this.date = 'Day';
      this.enroll_personal_valid = false;
    }
    if (this.month !== 'Month' ) {
      this.dates = [{value: 'Day', viewValue: 'Day'}];
      if (this.month == 1 || this.month == 3 || this.month == 5 ||
        this.month == 7 || this.month == 8 || this.month == 10 || this.month == 12 ) {
        let i = 1;
        for (i = 1; i <= 31; i++) {
          this.dates.push({value: '' + i, viewValue: '' + i});
        }
      }
      if (this.month == 4 || this.month == 6 || this.month == 9 || this.month == 11) {
        let i = 1;
        for (i = 1; i <= 30; i++) {
          this.dates.push({value: '' + i, viewValue: '' + i});
        }
      }
      if (this.month == 2) {
        const x = (this.year % 100 == 0) ? (this.year % 400 == 0) : (this.year % 4 == 0);
        if (this.year == 'Year' || x) {
        let i = 1;
        for (i = 1; i <= 29; i++) {
          this.dates.push({value: '' + i, viewValue: '' + i});
        }
      }else {
        let i = 1;
        for (i = 1; i <= 28; i++) {
        this.dates.push({value: '' + i, viewValue: '' + i});
        }
      }
      }
    }

    if (this.month != undefined && this.month != '' && this.month != 'Month' &&
    this.date != undefined && this.date != '' && this.date != 'Day' && this.year != undefined &&
    this.year != '' && this.year != 'Year') {
        this.date_of_birth = this.year + '-' + this.month + '-' + this.date;
        if (new Date(this.month + '/' + this.date + '/' + this.year).getDate() == this.date) {
            if (new Date(this.month + '/' + this.date + '/' + this.year) <= this.maxDate) {
                this.is_dob_valid = false;
            }else {
              this.is_dob_valid = true;
              this.date_error_message = 'You must be 18 years of age or older to enroll with Pogo Energy.';
              this.date_of_birth = '';
            }
        }else {
            this.date_of_birth = '';
            this.date = 'Day';
            this.is_dob_valid = true;
            this.date_error_message = 'Please provide a valid date to continue.';
        }
    }

    if (this.first_name != '' && this.last_name != '' && this.mobile_phone_number != '' &&
    this.first_name != undefined && this.last_name != undefined &&
    this.mobile_phone_number != undefined && this.mobile_phone_number.match(MOBILE_REGEX) &&
    this.first_name.match(LETTERS_REGEX) && this.last_name.match(LETTERS_REGEX) &&
    this.mobile_phone_number.match(MOBILE_REGEX) &&  this.date_of_birth !== '' &&
    this.date_of_birth != undefined && this.month != 'Month' && this.date != 'Day' && this.year != 'Year') {
      this.enroll_personal_valid = true;
        this.is_mobile_no_exist = false;
        if (personal != undefined) {
            if (personal.keyCode == 13) {
              document.getElementById('btn-click-personal').click();
            }
        }
    }else {
       this.enroll_personal_valid = false;
    }
  }

  createEnrollPersonal() {
    this.is_mobile_no_exist = false;
    this.sharedService.setHeaderErrorMessage('personal', false, 'notification error', '');
    if (!this.first_name.match(LETTERS_REGEX)) {
      window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'Please enter valid first name.');
    }else if (!this.last_name.match(LETTERS_REGEX)) {
      window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'Please enter valid last name.');
    }else if (!this.mobile_phone_number.match(MOBILE_REGEX)) {
      window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'Please enter valid 10 digit mobile no.');
    }else {
      this.customerEnrollService.checkMobileNoAlreadyRegister({'mobile_phone_number': this.mobile_phone_number}).then(res => {
          if (res.status === 'success') {
            if (res.is_exists) {
              this.is_mobile_no_exist = false;
              this.goToStep('account');
            }else {
              window.scrollTo(0, 0);
              // this.is_mobile_no_exist = true;
              this.sharedService.setHeaderErrorMessage('personal', true, 'notification error',
              'This phone number is currently in use on an existing account.  Please enter a different number or call us at 888.764.6669.');
            }
          }
      });

    }
  }

  // validation of account wizard
  enrollAccountValidate(account: any) {
    if (this.create_password !== '' && this.confirm_password !== '' &&
    this.prefered_language !== '' && this.create_password !== undefined &&
    this.confirm_password !== undefined && this.prefered_language !== undefined &&
    this.create_password.length > 5 && this.confirm_password.length > 5 &&
    this.create_password.match(PASSWORD_REGEX) && (this.create_password === this.confirm_password)) {
      this.enroll_account_valid = true;
      if (account !== undefined) {
        if (account.keyCode === 13) {
          document.getElementById('btn-click-account').click();
        }
      }
    }else {
      this.enroll_account_valid = false;
    }
  }

  createEnrollAccount() {
      this.sharedService.setHeaderErrorMessage('personal', false, 'notification error', '');
      if (!this.create_password.match(PASSWORD_REGEX)) {
        window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('personal', true, 'notification error',
        'Password must be 6-18 characters and contain at least one number and one letter.');
      }else if (!(this.create_password === this.confirm_password)) {
        window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('personal', true, 'notification error', 'Please enter valid confirm password.');
      }else {
        this.goToStep('service');
      }
  }
  confirmPasswordMatch(event: any) {
    if (this.create_password !== '' && event.keyCode !== 13) {
        this.confirm_password = '';
    }
  }

  // service wizard method
  enrollServiceValidate(service: any) {
    if (this.service_type !== '' && this.billing_address !== '' && this.city !== '' &&
    this.state !== '' && this.zip_code !== '' && this.service_type !== undefined &&
    this.service_start_date !== undefined && this.billing_address !== undefined &&
    this.city !== undefined && this.state !== undefined && this.zip_code !== undefined &&
    this.service_start_date != null && this.city.match(LETTERS_REGEX) &&
    this.state.match(LETTERS_REGEX) && this.zip_code.match(ZIPCODE_REGEX)) {
      this.enroll_service_valid = true;
      this.date_service_start = this.service_start_date.getFullYear() + '-' +
      (this.service_start_date.getMonth() + 1 ) + '-' + this.service_start_date.getDate();
      this.localStorageService.set('service_start_date' , this.service_start_date);
      if (service !== undefined) {
       if (service.keyCode === 13) {
        document.getElementById('btn-click-service').click();
       }
      }
    }else {
      this.enroll_service_valid = false;
    }
  }

  createEnrollService() {
    this.goToStep('summary');
  }

  ngOnInit() {
    const len = document.getElementsByTagName('body')[0];
    if (len !== undefined) {
        if  (len.classList.contains('body_autocomplete')) {
          len.classList.remove('body_autocomplete');
        }
    }

    setTimeout(function(){
      const setPos = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-container')[0];
      if  (setPos !== undefined) {
        if  (setPos.classList.contains('cdk-overlay-container-static')) {
          setPos.classList.remove('cdk-overlay-container-static');
        }
      }
    }, 10);
  }

  confirmCreateCustEnroll() {      
       this.customer_enroll_object = {
        'critical_care' : this.critical_care,
        'first_name' : this.first_name.trim(),
        'last_name' : this.last_name.trim(),
        'mobile_phone_number' : this.mobile_phone_number,
        'date_of_birth' : this.date_of_birth,
        'create_password' : this.create_password,
        'confirm_password' : this.confirm_password,
        'prefered_lang' : this.prefered_language,
        'service_type' : this.service_type,
        'service_start_date' : '' + this.date_service_start,
        'billing_address' : this.billing_address.trim(),
        'billing_address_2' : this.billing_address_2.trim(),
        'city' : this.city.trim(),
        'state' : this.state.trim(),
        'zip_code' : this.zip_code,
        'service_address' : this.billing_address_obj['address'],
        'service_address_2' : '',
        'service_city' : this.billing_address_obj['city'],
        'service_state' : this.billing_address_obj['state'],
        'service_zip_code' : this.billing_address_obj['zipcode'],
        'esi_id' : this.billing_address_obj['esi_id'],
        'IPAddress' : this.ip_Address,
      };
       this.btn_value = 'Sign Up...';
       this.disable_div = 'disable-div';
       this.is_enroll_processing = false;
       this.is_enroll_process = false;
       this.customerEnrollService.createCustEnroll(this.customer_enroll_object).then(res => {
          this.is_enroll_processing = true;
          this.is_enroll_process = true;
          this.disable_div = '';
          if (res.result.status === 'success') {
            this.localStorageService.set('token', res.result.token);
            this.router.navigate(['./otp-verify/' + res.result.username]);
            this.btn_value = 'Sign Up';
          }else {
            window.scrollTo(0, 0);
            this.sharedService.setHeaderErrorMessage('summary', true, 'notification error', res.result.message);
            this.btn_value = 'Sign Up';
          }
      });
  }


  setStatus() {
    if (this.is_enroll_process) {
      this.is_enroll_processing = this.terms_condition;
    }
  }

  sameAsServiceAddress() {
          this.billing_address = this.billing_address_obj['address'];
          this.billing_address_2 = '';
          this.city = this.billing_address_obj['city'];
          this.state = this.billing_address_obj['state'];
          this.zip_code = this.billing_address_obj['zipcode'];
          this.enrollServiceValidate('');
    }

  goToStep(step: string) {
    this.doing_personal = '';
    this.doing_account = '';
    this.doing_service = '';
    this.doing_summary = '';
    this.complete_personal = '';
    this.complete_account = '';
    this.complete_service = '';
    this.complete_summary = '';
    this.is_doing_personal = false;
    this.is_doing_account = false;
    this.is_doing_service = false;
    this.is_doing_summary = false;
    this.is_completed_personal = false;
    this.is_completed_account = false;
    this.is_completed_service = false;
    this.is_completed_summary = false;
    switch (step) {
    case 'personal': {
    (window as any).dataLayer.push({'event': 'enroll - step 1'});
    this.doing_personal = 'doing';
    this.is_doing_personal = true;
    break;
    }
    case 'account': {
    (window as any).dataLayer.push({'event': 'enroll - step 2'});
    this.doing_account = 'doing';
    this.complete_personal = 'complete';
    this.is_doing_account = true;
    this.is_completed_personal = true;
        break;
    }
    case 'service': {
    (window as any).dataLayer.push({'event': 'enroll - step 3'});
    this.doing_service = 'doing';
    this.complete_personal = 'complete';
    this.complete_account = 'complete';
    this.is_doing_service = true;
    this.is_completed_personal = true;
    this.is_completed_account = true;
    break;
    }
    case 'summary': {
    (window as any).dataLayer.push({'event': 'enroll - step 4'});
    this.doing_summary = 'doing';
    this.complete_personal = 'complete';
    this.complete_account = 'complete';
    this.complete_service = 'complete';
    this.is_doing_summary = true;
    this.is_completed_personal = true;
    this.is_completed_account = true;
    this.is_completed_service = true;
    break;
    }
    default: {
    this.doing_personal = 'doing';
    this.is_doing_personal = true;
    this.is_completed_personal = true;
    break;
    }
    }
  }

  mobilePhoneInfo() {
    this.dialog.open(MobilePhoneInfo);
  }

  dateOfBirthInfo() {
    this.dialog.open(DateOfBirthInfo);
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'mobile-phone-info',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><div class="dialog-info"><h3 class="text-center">Why we need your mobile phone number</h3><p>You will use this number to sign into your account. We will use this number to send you important alerts about your balance and your account. We will not sell your phone number to 3rd parties. We hate SPAM as much as you do. (Text message and data rates may apply.)</p></div></div><div class="footer"><button mat-button class="single-btn" [mat-dialog-close]="true">OK</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class MobilePhoneInfo {

}


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'date-of-birth-info',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><div class="dialog-info"><h3 class="text-center">Why We Ask For Your Date of Birth</h3><p>You must be 18 years of age or older to enroll with Pogo Energy. Also, your two digit month and last two digits of your year of birth will be used as your default PIN to verify your identity should you ever need to talk to us.</p></div></div><div class="footer"><button mat-button class="single-btn" [mat-dialog-close]="true">OK</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class DateOfBirthInfo {

}


export class PasswordValidation {
    static MatchPassword(AC: AbstractControl) {
       const password = AC.get('passwordFormControl').value; // to get value in input tag
       const confirmPassword = AC.get('confirmPasswordFormControl').value; // to get value in input tag
        if (password !== confirmPassword) {
            AC.get('confirmPasswordFormControl').setErrors( {MatchPassword: true} )
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-enroll/customer-enroll-wizard/customer-enroll-wizard.component.ts